export default [
  
  {
    path: '/chebi/jumptopay',
    name: 'jumptopay',
    component: () => import('@/views/chebi/jumptopay'),
    meta: {
      title: ''
    }
  },
  {
    path: '/chebi/recharge',
    name: 'recharge',
    component: () => import('@/views/chebi/recharge'),
    meta: {
      title: '车币充值'
    }
  }
]
